import React, { useEffect, useRef } from "react";

import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Typography } from "@progress/kendo-react-common";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
// import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../../_helper/helper";
import { PRINT_ACCESS } from "../../../_contstants/common";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getKarigarWiseMinaAmountLedgerReport } from "../services/reports.services";
import { sumBy } from "lodash";

const MinaKarigarLedgerReportView: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const fromdate = params.fromdate;
  const todate = params.todate;
  const karigar_id = params.karigar_id;
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.reports.loading);
  const KarigarWiseMinaAmountLedgerReportList = useAppSelector(
    (state) => state.reports.KarigarWiseMinaAmountLedgerReportList,
  );

  const isPrintAccess = checkAcessRights(
    "/mina-karigar-ledger-report",
    PRINT_ACCESS,
  );

  const fetchKarigarWiseMinaAmountLedgerReport = async (payload: any) => {
    await dispatch(getKarigarWiseMinaAmountLedgerReport(payload));
  };

  useEffect(() => {
    if (fromdate && todate && karigar_id) {
      const payload = {
        karigar_id: karigar_id,
        from_date: fromdate,
        to_date: todate,
      };
      fetchKarigarWiseMinaAmountLedgerReport(payload);
    }
  }, []);

  const printTable = () => {
    window.print();
    return;
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayoutItem>
            <div
              className="printbuttons"
              style={{
                textAlign: "center",
                padding: "20px",
                display: "block",
              }}
            >
              {/* {isExcelExportAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                    backgroundColor: "#3b823b",
                  }}
                >
                  <PiMicrosoftExcelLogoFill style={{ fontSize: "20px" }} />{" "}
                  Excel Export
                </Button>
              )} */}
              {isPrintAccess && (
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={printTable}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <Typography.h5
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              Mina Karigar Ledger Report
            </Typography.h5>
            <Typography.h6
              style={{
                marginBottom: 5,
                textAlign: "center",
              }}
            >
              (
              {fromdate
                ? moment(fromdate, "YYYY-MM-DD").format("DD/MM/YYYY")
                : ""}
              {" to "}
              {todate ? moment(todate, "YYYY-MM-DD").format("DD/MM/YYYY") : ""})
            </Typography.h6>
            <Typography.h5
              style={{
                textAlign: "center",
                fontSize: "18px",
              }}
            >
              Karigar:{" "}
              {
                KarigarWiseMinaAmountLedgerReportList?.[0]
                  ?.karigar_name
              }
            </Typography.h5>
          </GridLayoutItem>
          {/* REPORT LIST */}
          {KarigarWiseMinaAmountLedgerReportList &&
          KarigarWiseMinaAmountLedgerReportList.length > 0 ? (
            <div className="karigar-phine-ledger">
              <div className="table-container">
                <table className="ledger-table">
                  <thead>
                    <tr>
                      <th
                        className="col-date text-center"
                        style={{ width: "10%" }}
                      >
                        Order No
                      </th>
                      <th
                        className="col-date text-center"
                        style={{ width: "10%" }}
                      >
                        Received Date
                      </th>
                      <th
                        className="col-date text-center"
                        style={{ width: "10%" }}
                      >
                        Product Name
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "10%" }}
                      >
                        Issue Weight
                      </th>
                      <th
                        className="col-issue-net-weight text-end"
                        style={{ width: "10%" }}
                      >
                        Received Weight
                      </th>
                      <th
                        className="col-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Mina Weight
                      </th>
                      <th
                        className="col-net-weight text-end"
                        style={{ width: "8%" }}
                      >
                        Mina Rate
                      </th>
                      <th
                        className="col-receipt-amount text-end"
                        style={{ width: "10%" }}
                      >
                        Total Charge
                      </th>
                      <th
                        className="col-balance text-end"
                        style={{ width: "15%" }}
                      >
                        Balance
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {KarigarWiseMinaAmountLedgerReportList.map(
                      (data, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td className="cell-date text-center">
                            {data?.order_no}
                          </td>
                          <td className="cell-date text-center">
                            {data?.Date}
                          </td>
                          <td
                            className="cell-desc"
                            style={{
                              fontWeight: index === 0 ? "bold" : "normal",
                            }}
                          >
                            {index === 0 ? `Opening Balance` : data?.item_name}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.issue_weight
                              ? formatWeight(data?.issue_weight)
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.received_weight
                              ? formatWeight(+data?.received_weight)
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.mina_weight
                              ? formatWeight(+data?.mina_weight)
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {(data?.charges || 0) * (data?.mina_weight || 0)
                              ? formatToIndianCurrencyWithoutSymbol(
                                  +(data?.charges || 0) *
                                    +(data?.mina_weight || 0),
                                )
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {data?.total_charge
                              ? formatToIndianCurrencyWithoutSymbol(
                                  data?.total_charge,
                                )
                              : ""}
                          </td>
                          <td className="cell-issue-no text-end">
                            {index === 0
                              ? data?.amount_opening_balance
                                ? formatToIndianCurrencyWithoutSymbol(
                                    data?.amount_opening_balance,
                                  )
                                : ""
                              : data?.closing_amount
                                ? formatToIndianCurrencyWithoutSymbol(
                                    data?.closing_amount,
                                  )
                                : ""}
                            {data.creditdebittypeamount === "Credit"
                              ? "Cr"
                              : "Dr"}
                          </td>
                        </tr>
                      ),
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="totals-row">
                      <td colSpan={3} className="totals-label">
                        TOTALS
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseMinaAmountLedgerReportList,
                            "issue_weight",
                          )
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseMinaAmountLedgerReportList,
                            "received_weight",
                          )
                        )}
                      </td>
                      <td className="total-issue text-end">
                        {formatWeight(
                          sumBy(
                            KarigarWiseMinaAmountLedgerReportList,
                            "mina_weight",
                          )
                        )}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          ) : null}
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default MinaKarigarLedgerReportView;
